var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Created with Pixso.\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip206_2284"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "smile",
    width: 32,
    height: 32,
    transform: "translate(-0.496094 -0.500000)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "smile",
    width: 32,
    height: 32,
    transform: "translate(-0.496094 -0.500000)",
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip206_2284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 27.16C12.41 27.16 9.44 25.93 7.25 23.74C5.06 21.56 3.83 18.59 3.83 15.5C3.83 12.4 5.06 9.43 7.25 7.25C9.44 5.06 12.41 3.83 15.5 3.83C18.59 3.83 21.56 5.06 23.75 7.25C25.94 9.43 27.17 12.4 27.17 15.5C27.17 18.59 25.94 21.56 23.75 23.74C21.56 25.93 18.59 27.16 15.5 27.16ZM15.5 28.83C19.04 28.83 22.43 27.42 24.93 24.92C27.43 22.42 28.83 19.03 28.83 15.5C28.83 11.96 27.43 8.57 24.93 6.07C22.43 3.57 19.04 2.16 15.5 2.16C11.96 2.16 8.57 3.57 6.07 6.07C3.57 8.57 2.17 11.96 2.17 15.5C2.17 19.03 3.57 22.42 6.07 24.92C8.57 27.42 11.96 28.83 15.5 28.83Z",
    fill: "#777777",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.31 18.11C9.4 18.05 9.51 18.02 9.62 18C9.72 17.99 9.83 18 9.94 18.02C10.04 18.05 10.14 18.1 10.23 18.17C10.32 18.23 10.39 18.32 10.45 18.41C10.83 19.08 11.34 19.66 11.95 20.12C12.55 20.59 13.25 20.93 13.99 21.13C14.73 21.33 15.5 21.38 16.26 21.28C17.02 21.18 17.75 20.93 18.42 20.55C19.3 20.04 20.04 19.3 20.55 18.41C20.61 18.32 20.68 18.23 20.77 18.16C20.85 18.1 20.95 18.05 21.06 18.02C21.16 17.99 21.28 17.98 21.38 18C21.49 18.01 21.6 18.05 21.69 18.1C21.79 18.16 21.87 18.23 21.94 18.32C22 18.4 22.05 18.5 22.08 18.61C22.11 18.72 22.12 18.83 22.1 18.94C22.09 19.04 22.05 19.15 22 19.24C21.34 20.39 20.39 21.33 19.25 21.99C18.11 22.65 16.82 23 15.5 23C14.18 23 12.89 22.65 11.75 21.99C10.61 21.33 9.66 20.38 9 19.24C8.89 19.05 8.86 18.83 8.92 18.61C8.98 18.4 9.12 18.22 9.31 18.11ZM13.83 13C13.83 14.37 13.09 15.5 12.17 15.5C11.25 15.5 10.5 14.37 10.5 13C10.5 11.62 11.25 10.5 12.17 10.5C13.09 10.5 13.83 11.62 13.83 13ZM20.5 13C20.5 14.37 19.75 15.5 18.83 15.5C17.91 15.5 17.17 14.37 17.17 13C17.17 11.62 17.91 10.5 18.83 10.5C19.75 10.5 20.5 11.62 20.5 13Z",
    fill: "#777777",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileIcon);
export default __webpack_public_path__ + "static/media/smileIcon.8b4ff6dbe43fff0c516e3d6a02e70e50.svg";
export { ForwardRef as ReactComponent };